export default {
  type: "Feature",
  properties: {
    name: "Даланзадгад",
    location: [43.16446, 103.52475],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [99.59687948226929, 42.57930224162034],
        [99.5965576171875, 42.73289174571287],
        [99.580078125, 42.85985981506279],
        [99.49218749999999, 43.203173782105814],
        [99.4482421875, 43.51668853502909],
        [99.44549560546874, 43.8543357707896],
        [99.41528320312499, 44.050089820756796],
        [99.45373535156249, 44.10730980734024],
        [99.55810546875, 44.125056482685146],
        [99.64324951171875, 44.14082683077555],
        [99.7833251953125, 44.14476875978378],
        [99.91790771484375, 44.07377376789347],
        [100.01678466796875, 44.04219306625442],
        [100.23101806640625, 43.8503744993026],
        [100.40130615234375, 43.810747313446996],
        [100.58258056640625, 43.83254552160589],
        [101.15936279296875, 43.83650797709095],
        [101.2774658203125, 43.84839376489157],
        [101.4093017578125, 43.89789239125797],
        [101.74713134765625, 43.99676629896825],
        [101.8077278137207, 44.04897940326519],
        [101.80755615234375, 44.050089820756796],
        [102.06298828125, 44.11716972942086],
        [102.3870849609375, 44.156592967556605],
        [102.996826171875, 44.15462243076731],
        [102.93365478515625, 44.264871151101985],
        [102.93365478515625, 44.314022698837775],
        [102.9638671875, 44.36902359940364],
        [103.03802490234375, 44.439663223436106],
        [103.07922363281249, 44.555249259710656],
        [103.2440185546875, 44.80132682904856],
        [103.31817626953125, 44.824708282300236],
        [103.35113525390625, 44.88506649401471],
        [103.5736083984375, 44.96674121705534],
        [103.71093749999999, 45.06770141120143],
        [103.7823486328125, 45.17041997262667],
        [103.7823486328125, 45.17235628126675],
        [104.01031494140625, 45.18397275067566],
        [104.10919189453125, 45.20139301126898],
        [104.16824340820312, 45.097760877277096],
        [104.20944213867186, 44.94924926661153],
        [104.26712036132812, 44.83249999349062],
        [104.359130859375, 44.77403648591524],
        [104.71481323242188, 44.715513732021336],
        [104.81781005859374, 44.68525376315066],
        [104.99633789062499, 44.66962952692013],
        [105.12680053710938, 44.687206496456966],
        [105.42068481445312, 44.687206496456966],
        [105.50445556640625, 44.67744217165251],
        [105.5731201171875, 44.55916341529184],
        [105.7159423828125, 44.41122141189896],
        [105.74066162109375, 44.34644018791789],
        [105.76263427734375, 44.31205742666618],
        [105.80520629882812, 44.288469027276506],
        [105.96176147460938, 44.19303602884215],
        [106.06063842773438, 44.17826452922576],
        [106.13067626953125, 44.18220395771566],
        [106.22817993164061, 44.19795903948531],
        [106.292724609375, 44.21863119293724],
        [106.3641357421875, 44.265854585146684],
        [106.42318725585936, 44.29240108529005],
        [106.50421142578125, 44.308126684886126],
        [106.57699584960938, 44.351350365612305],
        [106.68136596679686, 44.38865427337759],
        [106.78848266601562, 44.43083793524685],
        [106.93130493164062, 44.457309801319305],
        [107.18536376953125, 44.491607329696045],
        [107.24716186523438, 44.50923820945519],
        [107.29660034179686, 44.51609322284931],
        [107.33779907226562, 44.512176171071054],
        [107.41333007812499, 44.49258696288604],
        [107.45040893554688, 44.491607329696045],
        [107.49160766601561, 44.49650533109348],
        [107.57812499999999, 44.520989167323734],
        [107.68730163574217, 44.554270679675696],
        [107.68798828125, 44.555249259710656],
        [107.64816284179686, 44.36313311380771],
        [107.64678955078125, 44.30419567985762],
        [107.7923583984375, 44.109281923355645],
        [107.83355712890625, 43.98886243884903],
        [107.85552978515625, 43.90778718292443],
        [107.95440673828125, 43.69766549666678],
        [107.9571533203125, 43.61619382369188],
        [107.93792724609375, 43.52266348752663],
        [107.9296875, 43.31118965238512],
        [107.95166015624999, 43.257205668363206],
        [108.00384521484375, 43.17113228474479],
        [108.017578125, 43.0287452513488],
        [108.0340576171875, 42.93631775765237],
        [108.0120849609375, 42.85381962412133],
        [108.00933837890625, 42.70060440808085],
        [107.9791259765625, 42.589488572714245],
        [107.98393249511719, 42.42877840024783],
        [107.9791259765625, 42.412304442420684],
        [107.97775268554688, 42.412304442420684],
        [107.95303344726562, 42.412304442420684],
        [107.91732788085938, 42.40115038362433],
        [107.82806396484375, 42.4112905190282],
        [107.56301879882812, 42.4112905190282],
        [107.4957275390625, 42.45588764197166],
        [107.4407958984375, 42.4639928001706],
        [107.2869873046875, 42.4112905190282],
        [107.24853515625, 42.362602921719954],
        [107.03979492187499, 42.313877566161864],
        [106.7706298828125, 42.293564192170095],
        [105.58959960937499, 41.898188430430444],
        [105.281982421875, 41.74672584176937],
        [105.216064453125, 41.74262728637672],
        [105.0018310546875, 41.582579601430346],
        [104.9139404296875, 41.64828831259535],
        [104.6722412109375, 41.64007838467894],
        [104.51293945312499, 41.65649719441145],
        [104.5184326171875, 41.87774145109676],
        [104.0679931640625, 41.80817277478235],
        [103.8482666015625, 41.795888098191426],
        [103.37585449218749, 41.89409955811395],
        [102.7056884765625, 42.14304156290942],
        [102.535400390625, 42.15933157601718],
        [102.4365234375, 42.14304156290942],
        [102.073974609375, 42.224449701009725],
        [101.7938232421875, 42.50450285299051],
        [101.62902832031249, 42.52069952914966],
        [100.8599853515625, 42.67031977251908],
        [100.32714843749999, 42.69051116998241],
        [100.2667236328125, 42.63799988907408],
        [99.9700927734375, 42.64204079304428],
        [99.5965576171875, 42.5808940890009],
        [99.59687948226929, 42.57930224162034],
      ],
    ],
  },
};
